import React from 'react';
import ShowMoreDivider from '@components/leaderboard/ShowMoreDivider';
import ExamResultTableItem, {
  ExamResultTableItemProps,
} from '@components/exam_result/list/ExamResultTableItem';
import ExamResultEmptyState from '../ExamResultEmptyState';

export interface ExamResultTableProps {
  ExamResultList: ExamResultTableItemProps[];
  showMore: boolean;
  onShowMore: () => void;
}

const ExamResultTable = ({
  ExamResultList,
  showMore,
  onShowMore,
}: ExamResultTableProps) => {
  return ExamResultList.length > 0 ? (
    <>
      <div
        className={
          'w-full py-3 px-4 rounded-2xl bg-primary-navyblue-shade/[0.65] flex flex-row items-center gap-4 font-bold text-sm max-lg:text-xs max-sm:justify-center max-sm:!pl-6'
        }
      >
        <div className={'flex-none w-[15%] max-sm:w-[25%]'}>Subject</div>
        <div className={'flex-none w-[10%] max-sm:hidden'}>Level</div>
        <div className={'flex-none w-[5%] text-center max-sm:w-[15%]'}>
          {window.innerWidth <= 640 ? 'Exam' : 'Type'}
        </div>
        <div className={'flex-none w-[20%] text-center max-sm:w-[18%]'}>
          Date
        </div>
        <div className={'flex-none w-[12%] text-center max-sm:w-[18%]'}>
          Mark
        </div>
        <div className={'flex-none w-[12%] text-center max-sm:hidden'}>
          Grade
        </div>
        <div className={'flex-none w-[6%] text-center max-sm:hidden'}>
          Image
        </div>
        <div className={'flex-none w-[15%] text-center max-sm:w-[5%]'}></div>
      </div>
      <div
        className={
          'overflow-y-auto no-scrollbar max-sm:h-[calc(100vh-450px)] max-md: h-[calc(100vh-500px)]'
        }
      >
        {ExamResultList.map(item => (
          <ExamResultTableItem {...item} key={item.id} />
        ))}
        {!showMore && ExamResultList.length > 0 ? (
          <div className={'mb-5'}>
            <ShowMoreDivider onShowMore={onShowMore} />
          </div>
        ) : null}
      </div>
    </>
  ) : (
    <div
      className={'max-sm:h-[calc(100vh-390px)] max-md: h-[calc(100vh-400px)]'}
    >
      <ExamResultEmptyState />
    </div>
  );
};

export default ExamResultTable;
